<template>
  <div class="bidding">
    <Navbar />
    <div class="mt-5 pt-5 kovatek-width">
        <div class="px-0 mx-3 px-sm-2 mx-sm-3 px-md-3 mx-md-3 px-lg-4 mx-lg-4">
            <div class="text-left mt-3 ml-5 mb-4"><a-icon class="mr-1" type="arrow-left" /> <span class="go-back">Go Back</span></div>
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-8">
                    <div class="row">
                        <div class="col-8">
                            <h4 class="font-weight-bolder kova-text text-left">Customise Wordpress Login</h4>
                        </div>
                        <div class="col-4">
                            <h4 class="kova-text font-weight-bolder text-left">$20 - $169</h4>
                        </div>
                    </div>
                    <div>
                        <a-tabs defaultActiveKey="1">
                            <a-tab-pane tab="Details" key="1">
                                <div class="bg-light border add-rounded p-4 mt-4">
                                    <div class="row">
                                        <div class="col-12 col-sm-12 col-md-9">
                                            <div class="row pl-3">
                                                <div><h5 class="font-weight-bolder text-left">Customise Wordpress Login</h5></div>
                                                <a-tooltip placement="topLeft">
                                                    <template slot="title">
                                                        <span><a-icon class="mr-2" type="info-circle" style="position:relative; bottom: 3px;font-size: 16px;"/>click to copy</span>
                                                    </template>
                                                    <span class="ml-2">
                                                        <div class="id ml-3 text-white">ID: 23498</div>
                                                    </span>
                                                </a-tooltip>
                                                    </div>
                                            <h5 class="text-left mt-3">Brief</h5>
                                            <p class="text-left">
                                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
                                                eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
                                                voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita
                                                kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
                                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
                                                eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
                                            </p>
                                            <h5 class="text-left mt-3">Skills Required</h5>
                                            <div class="text-left d-flex flex-wrap">
                                                <span class="bg-skills px-3 py-2 mr-3 mb-3 rounded ctrl-size-2"  v-for="skill in skills" :key="skill">
                                                    {{skill}}</span>
                                            </div>
                                            <h5 class="text-left mt-3">Budgets</h5>
                                            <div class="row pl-3">
                                                <div><h4 class="text-left font-weight-bolder">$1,340 - $3,000 .</h4></div>
                                                <div class="ml-3 mt-2 incr-font-2 font-italic">$20.00/hr</div>
                                            </div>

                                        </div>
                                        <div class="col-12 col-sm-12 col-md-3">
                                            <div class="text-right font-weight-bolder"><font-awesome-icon icon="clock" class="mr-2"/>Bidding closed</div>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4"/>
                            </a-tab-pane>
                            <a-tab-pane tab="Proposals" key="2" forceRender>
                                <div class="mt-4 mb-5">
                                    <div class="p-4 bg-light border shadow-sm add-rounded">
                                        <div :key="work" v-for="work in workHistory">
                                            <div class="row">
                                            <div class="class col-3 col-sm-3 col-md-2 pl-1">
                                                <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle img-height" />
                                            </div>
                                            <div class="col-9 col-sm-9 col-md-7 text-left">
                                                <h5 class="font-weight-bolder kova-text">{{work.title}}</h5>
                                                <!-- <span>
                                                    <span :key="n" v-for="n in work.star"><font-awesome-icon icon="star" size=""></font-awesome-icon></span> <b>{{work.star}}.00</b> 
                                                    <span class="font-weight-light">{{work.duration}}</span>
                                                </span> -->
                                                <p class="font-italic ctrl-size-2">{{work.comment}}</p>
                                                <div class="text-left d-flex flex-wrap">
                                                    <span class="bg-skills px-3 py-2 mr-3 mb-3 rounded ctrl-size-2"  v-for="skill in proSkills" :key="skill">
                                                        {{skill}}</span>
                                                </div>
                                            </div>
                                            
                                            <!-- <div class="col-md-3">

                                            </div> -->
                                            <div class="pl-4 pl-sm-5 pl-md-3 mt-3 mt-md-0 col-12 col-sm-12 col-md-3 text-right float-text">
                                            <h5 class="font-weight-bolder kova-text">${{work.earned}}</h5>
                                            <h6>Web Developer <span class="text-uppercase intermediate">intermediate</span> </h6>
                                            <!-- <h6>{{work.hours}} hours </h6> -->
                                            <span class="ml-2"><img class="mr-2" src="../assets/kovatek/best.svg" alt="" /><span class="font-weight-bolder ctrl-size-1">9.5</span><span class="ml-2 ctrl-size-2">56 reviews</span></span>

                                            </div>
                                        </div>
                                        <hr>
                                        </div>
                                        
                                    </div>
                                </div>
                            </a-tab-pane>
                        </a-tabs>
                    </div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-4 px-0 pt-lg-4 pl-lg-4 mt-lg-5">
                    <div class="pt-2 mt-1"></div>
                    <div class="bg-light border add-rounded mt-5 px-3 pb-3">
                        <h5 class="font-weight-bolder mt-4 text-left">Currently Hired</h5>
                        <div class="row">
                            <div class="col-4 col-md-5 col-lg-4">
                                <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle img-height" />
                            </div>
                            <div class="col-8 col-md-7 col-lg-8 pl-3">
                                <h4 class="font-weight-bolder kova-text text-left">Johnson. K </h4>
                                <h6 class="text-left font-italic">Web Developer</h6>
                                <h6 class="intermediate font-weight-bolder text-left text-uppercase">intermediate</h6>
                            </div>
                        </div>
                        <div class="mt-4 add-rounded kova-bg p-4">
                            <div class="row text-left">
                                <div class="col-8 text-white"><h5 class="text-white text-size2">Skill Score</h5></div>
                                <div class="col-4 text-white"><h5 class="text-white text-size2">65%</h5></div>
                            </div>
                            <div class="row">
                                <div class="col-8 pl-3 text-left text-white">
                                   <p class="text-size3">Profile</p>
                                </div>
                                <div class="col-4 text-right text-white">
                                    <p class="">19</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-8 pl-3 text-left text-white">
                                    <p class="text-size3">Sprint Project Exercise</p>
                                </div>
                                <div class="col-4 text-right text-white">
                                     <p class="">22</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-8 pl-3 text-left text-white">
                                    <p class="text-size3">Live Interview</p>
                                </div>
                                <div class="col-4 text-right text-white">
                                    <p class="">24</p>
                                </div>
                            </div>
                            <button class="see-more px-3 px-md-4 px-lg-5 py-2 mt-3">see more</button>     
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Footer />
  </div>
</template>

<script>

import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'bidding',
  components: {
   Navbar, Footer
  },
  data(){
      return {
        skills: [
                'Laravel Framework', 'Nodejs','Golang','jQuery', 'JavaScript','database', 'Modeling','Vue.js','Express.js', 'Ext JS', 'Docker'
            ],
        workHistory: [
                {title: 'Adebayo Mary', duration: ' Mar 2016 - Sep 2018', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 963.34, earnedPerHour: 20.00, hours: 48},
                {title: 'Adebayo Mary', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 560.00, earnedPerHour: 30.00, hours: 19},
                {title: 'Adebayo Mary', duration: ' Mar 2016 - Sep 2018', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 963.34, earnedPerHour: 20.00, hours: 48},
                {title: 'Adebayo Mary', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 560.00, earnedPerHour: 30.00, hours: 19},
                {title: 'Adebayo Mary', duration: ' Mar 2016 - Sep 2018', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 963.34, earnedPerHour: 20.00, hours: 48},
                {title: 'Adebayo Mary', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 560.00, earnedPerHour: 30.00, hours: 19},
            ],
            proSkills: [
                'Vue.js','Express.js', 'Ext JS', 'Nodejs' 
            ]
      }
  },
  methods: {

  }
}
</script>
<style scoped>
.add-rounded{
    border-radius: 10px;
}
.bg-skills{
    background-color: #4BB38E;
    color: #fff;
}
.id{
    width: 100px;
    height: 20px;
    background-color: #4BB38E;
    border-radius: 5px;
}
.icon-size{
    font-size: 25px;
}
.img-height{
    width: 90px;
    height: 90px;
}
.ctrl-size{
    font-size: 16px;
}
.intermediate{
    color:rgb(148, 194, 20);
    font-size: 12px;
}
.ctrl-size-1{
    font-size: 20px
}
.ctrl-size-2{
    font-size: 12px;
}
.text-size1{
    font-size: 20px;
}
.text-size2{
    font-size: 18px;
}
.text-size3{
    font-size: 11px;
}
.see-more{
    background-color: transparent;
    border: solid 1.5px #fff;
    border-radius: 20px;
    color: #fff;
    transition: .25s;
}
.see-more:hover{
    background-color: #fff;
    color: #20409A
}
@media screen and (min-width: 992px) and (max-width: 1325px){
    
}

@media screen and (min-width: 992px) and (max-width: 1200px){
    .employer-name{
        font-size: 18px;
    } 
    .img-height{
        width: 70px;
        height: 70px;
    }
}

@media screen and (min-width: 768px) and (max-width: 991px){
   
}

@media screen and (max-width: 767px){
    .float-text{
        display: flex;
        justify-content: space-between;
        padding-right: 50px;
    }
    .float-text h6{
        float: left;
    }
}
/* 
@media screen and (max-width: 550px){
    
} */
</style>
